import { DESKTOP_BREAKPOINT } from 'src/constants/breakPoints'
import { BLACK } from 'src/constants/colors'

export const MAIN_FONT = 'Inter'
const FALLBACK_FONT = 'Metropolis'

enum FONT_WEIGHT {
  BOLD = 700,
  MEDIUM = 500,
  REGULAR = 400,
}

export const baseStyle = `
  color: ${BLACK.DEFAULT};
  font-family: ${MAIN_FONT}, ${FALLBACK_FONT};
  margin: 0;
`

export const h1Style = `
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: 24px;
  line-height: 28px;

  ${DESKTOP_BREAKPOINT} {
    font-size: 24px;
    line-height: 29px;
  }
`

export const h2Style = `
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: 20px;
  line-height: 23px;

  ${DESKTOP_BREAKPOINT} {
    font-size: 18px;
    line-height: 22px;
  }
`

export const h3Style = `
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: 18px;
  line-height: 21px;

  ${DESKTOP_BREAKPOINT} {
    font-size: 16px;
    line-height: 19px;
  }
`

export const pStyle = `
  font-weight: ${FONT_WEIGHT.REGULAR};
  font-size: 16px;
  line-height: 19px;

  ${DESKTOP_BREAKPOINT} {
    font-size: 14px;
    line-height: 17px;
  }
`

export const smallPStyle = `
  font-weight: ${FONT_WEIGHT.REGULAR};
  font-size: 14px;
  line-height: 17px;

  ${DESKTOP_BREAKPOINT} {
    font-size: 12px;
    line-height: 15px;
  }
`

export const buttonStyle = `
  font-weight: ${FONT_WEIGHT.MEDIUM};
  font-size: 18px;

  ${DESKTOP_BREAKPOINT} {
    font-size: 16px;
  }
`

export const smallButtonStyle = `
  font-weight: ${FONT_WEIGHT.MEDIUM};
  font-size: 16px;

  ${DESKTOP_BREAKPOINT} {
    font-size: 14px;
  }
`

export const labelStyle = `
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: 16px;
  line-height: 19px;

  ${DESKTOP_BREAKPOINT} {
    font-size: 14px;
    line-height: 17px;
  }
`

export const ActiveDesktopStepperStyle = `
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: 14px;
  line-height: 24px;
`

export const InactiveDesktopStepperStyle = `
  font-weight: ${FONT_WEIGHT.REGULAR};
  font-size: 14px;
  line-height: 24px;
`
